const columns = (t, restCols) => ([
	{
		caption: t('common.fields.code'),
		dataField: 'code',
		width: 100,
		allowEditing: false
	},
	{
		caption: t('options_section.fields.name'),
		dataField: 'name',
		width: 300,
		allowEditing: false
	},
	...restCols
])
export default columns
